import { useAppContext } from "../../AppProvider";
import { useDetailsIndexContext } from "../Shipments/providers/hooks";

export const ShipmentCostFooter = () => {
  const { dictionary } = useAppContext();
  const { data } = useDetailsIndexContext();

  return (
    <>
      <hr />
      <div className="d-flex justify-content-between">
        <label className="label-1">{dictionary.words.total}:</label>

        <div className="row w-50 text-center">
          <div className="col-6" style={{ borderRight: "1px solid #c7c9cd" }}>
            <label
              className={`label-1  ${data.ratingCost === 0 && "text-success"}`}
            >
              {data.ratingCost && data.ratingCost !== 0
                ? `${data.ratingCost.toFixed(2)} € `
                : dictionary.words.free}
            </label>
          </div>
          <div className="col-6">
            <label
              className={`label-1  ${data.ratingCost === 0 && "text-success"}`}
            >
              {data.ratingTime && data.ratingCost !== 0
                ? `${data.ratingTime} h`
                : "-"}
            </label>
          </div>
        </div>
      </div>
    </>
  );
};
